export const getStatusLabel = status => {
  const statusMap = {
    // Payment statuses
    initiated: 'Gestartet',
    pending: 'Ausstehend',
    authorised: 'Autorisiert',
    captured: 'Vollständig abgeschlossen',
    refunded: 'Zurückerstattet',
    partialRefund: 'Teilweise zurückerstattet',
    failed: 'Fehlgeschlagen',
    cancelled: 'Abgebrochen',
    timeout: 'Zeitüberschreitung',
    processed: 'Verarbeitet',
    // Voucher statuses
    active: 'Aktiv',
    waitingForPayment: 'Unbezahlt',
    used: 'Eingelöst',
    locked: 'Gesperrt',
    expired: 'Abgelaufen',
  };
  return statusMap[status] || status;
};

export const getPaymentMethodLabel = paymentMethod => {
  const methodMap = {
    paypal: 'PayPal',
    card: 'Kreditkarte',
    ideal: 'iDEAL',
    sepa: 'SEPA-Lastschrift',
    sofort: 'Sofortüberweisung',
  };
  return methodMap[paymentMethod] || paymentMethod;
};
